export enum ACTIONS {
  TOGGLE_SCOREBOARD = 'TOGGLE_SCOREBOARD',
}

export interface IScoreboardStatusState {
  isScoreboardOpen: boolean;
}
